import React, { useEffect, useMemo, useState } from "react";
import MemberTable from "../../Members/MembersTable";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import TableRowsLoader from "../../Loaders/TableRowsLoader";
import { TbReload } from "react-icons/tb";
import TableOnlyRowsLoading from "../../Loaders/TableOnlyRowsLoading";
import UpdateMemberModal from "../../Members/UpdateMemberModal";
import NewMemberModal from "../../Members/NewMemberModal";
import { BiPlus } from "react-icons/bi";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenOrgMembers = ({ account_id, userData, org_id }) => {
    const {t} = useLanguage()
    const [openModal, setOpenModal] = useState(false);
    const [openModalUpdate, setOpenModalUpdate] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [data, setDatata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedMember, setSelectedMember] = useState({})
    const [orgData, setOrgData] = useState([])
    const [loadingOrgData, setLoadingOrgData] = useState(false)

    const fetchData = async () => {
        if (!account_id) return;
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_single_org_members`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id
                }),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || "Failed to fetch");

            setDatata(result.data || []);
        } catch (err) {
            console.error("Error fetching members:", err);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    };

    const fetchOrgData = async (abilityId) => {
        setLoadingOrgData(true);

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_single_organizations_members`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch orgs");
            }

            setOrgData(result.data || []);
        } catch (err) {
            console.error("Error fetching organizations:", err);
        } finally {
            setLoadingOrgData(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [account_id]);

    const filteredAndSortedData = useMemo(() => {
        if (!data) return [];

        let result = data.filter((member) => {
            const term = searchTerm.toLowerCase();
            const nameMatch = `${member.name} ${member.surname}`.toLowerCase().includes(term);
            const emailMatch = member.email?.toLowerCase().includes(term);
            const statusMatch = member.status?.toLowerCase().includes(term);

            const orgMatch = member.organizations?.some(org =>
                org.name?.toLowerCase().includes(term)
            );

            return nameMatch || emailMatch || orgMatch || statusMatch;
        });

        result.sort((a, b) => {
            const nameA = a.name?.toLowerCase() || "";
            const nameB = b.name?.toLowerCase() || "";
            return sortOrder === "asc"
                ? nameA.localeCompare(nameB)
                : nameB.localeCompare(nameA);
        });

        return result;
    }, [data, searchTerm, sortOrder]);

    const handleOpenModalUpdate = (item) => {
        setSelectedMember(item)
        setOpenModalUpdate(true)
    }

    if (loading) return <TableOnlyRowsLoading />;

    return (
        <div className="analytics_cont_body_inner">
            {(data.length > 0 || searchTerm) && (
                <div className="filter_body_mainframe">
                    <div className="open_item_cont_table_header">
                        <button
                            className="open_item_cont_table_header_btn"
                            onClick={() => setOpenModal(true)}
                        >
                            <BiPlus />
                        </button>
                        <div className="filtering_mainframe_start">
                            <div className="filtering_mainframe_btn_cont fade-in">
                                {data.length > 1 && (
                                    <>
                                        <button className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`} onClick={() => setSortOrder("asc")} title="A-Z">
                                            <GrAscend />
                                        </button>
                                        <button className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`} onClick={() => setSortOrder("desc")} title="Z-A">
                                            <GrDescend />
                                        </button>
                                    </>
                                )}
                                <button className="filter_btn" onClick={() => fetchData()} title={t.reload}>
                                    <TbReload />
                                </button>
                            </div>
                            <div className="filter_input_cont fade-in">
                                <input
                                    className="filter_input"
                                    placeholder={t.search_filter}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                            </div>
                        </div>
                    </div>

                    <MemberTable
                        type="members"
                        data={filteredAndSortedData}
                        handleOpenModalUpdate={handleOpenModalUpdate}
                        userData={userData}
                    />
                </div>
            )}

            <NewMemberModal
                account_id={account_id}
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchData}
                userData={userData}
                orgData={orgData}
                fetchOrgData={fetchOrgData}
                org_id={org_id}
            />

            <UpdateMemberModal
                account_id={account_id}
                show={openModalUpdate}
                handleClose={() => setOpenModalUpdate(false)}
                fetchRecords={fetchData}
                selectedMember={selectedMember}
                userData={userData}
                orgData={orgData}
                fetchOrgData={fetchOrgData}
            />
        </div>
    )
}

export default OpenOrgMembers